import { digObject } from '@domain-group/javascript-utils'

import {
  Box, DashboardModule,
} from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'
import useAttachments from '@hooks/useAttachments'

import { NotificationModel } from '@models/notification'

import NotificationImageItem from '../NotificationImageItem'

interface NotificationImageProps {
  notificationPayload: {
    loading: boolean,
    notification: NotificationModel,
  },
}
const NotificationImage = (props: NotificationImageProps) => {
  const { notificationPayload } = props
  const {
    loading,
    notification,
  } = notificationPayload

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_id: notification.id,
      attachable_type: 'Notification',
      attachment_type: 'notification_image',
    },
    performHttpRequests: !!notification.id,
  })

  const { filteredAttachments } = attachmentsPayload
  const notificationImage = filteredAttachments[0]
    || { attachable_id: notification.id, attachable_type: 'Notification', attachment_type: 'notification_image' }

  const NotificationImageUrl = digObject(notificationImage, 'links.thumb_url')
  const { file_file_name } = notificationImage

  const {
    callbacks: {
      createOrEditAttachment,
    },
  } = useAttachment(notificationImage)

  return (
    <DashboardModule loading={loading} title="Images">
      {!loading && (
        <Box flexDirection="column">
          <NotificationImageItem
            callbacks={{
              launchModalFn: createOrEditAttachment,
            }}
            // @ts-expect-error TS2322
            fileName={file_file_name}
            imageUrl={NotificationImageUrl}
          />
        </Box>
      )}
    </DashboardModule>
  )
}

export default NotificationImage
